import {
  DirectionsCarFilled as AssetsIcon,
  PeopleAlt as CustomersIcon,
  GridViewSharp as DashboardIcon,
  RoomService as ReservationsIcon,
  LibraryBooks as ContractIocn,
  Settings as SettingsIcon,
  LocationOn,
  VerifiedUser,
  PersonSearch,
  Person,
  Commute as CommuteIcon,
  DirectionsCar,
  DriveFileRenameOutlineOutlined as DriveFileRenameOutlineOutlinedIcon,
  GradingOutlined as GradingOutlinedIcon,
  CarCrash,
  ElectricCar,
  AttachMoneyOutlined,
  FolderShared,
  Payment,
  Assessment,
  PersonAdd,
  Article,
  EventNote,
  LocalOffer,
  AccountBalanceOutlined,
} from "@mui/icons-material";
import { Box, Stack, SvgIcon, SvgIconProps, Typography } from "@mui/material";
import React from "react";

type IconSize = "small" | "medium" | "large";

interface IconProps extends SvgIconProps {
  iconName?: string;
  fontSize: IconSize;
  title?: string;
  isWithIcon?: boolean;
}

const IconComponent: React.FC<IconProps> = ({
  iconName,
  fontSize = "large",
  title = "",
  isWithIcon = true,
  ...props
}) => {
  const getIconComponent = () => {
    switch (iconName) {
      case "dashboard":
        return <DashboardIcon />;
      case "customer":
        return <CustomersIcon />;
      case "asset":
        return <AssetsIcon />;
      case "reservation":
        return <ReservationsIcon />;
      case "contract":
        return <ContractIocn />;
      case "setting":
        return <SettingsIcon />;
      case "location":
        return <LocationOn />;
      case "insurance":
        return <VerifiedUser />;
      case "user":
        return <PersonSearch />;
      case "profile":
        return <Person />;
      case "make":
        return <CommuteIcon />;
      case "model":
        return <DirectionsCar />;
      case "type":
        return <CarCrash />;
      case "option":
        return <ElectricCar />;
      case "rateName":
        return <DriveFileRenameOutlineOutlinedIcon />;
      case "ratePlan":
        return <GradingOutlinedIcon />;
      case "tax":
        return <AttachMoneyOutlined />;
      case "client":
        return <FolderShared />;
      case "payment":
        return <Payment />;
      case "finance":
        return <Assessment />;
      case "additionalDriver":
        return <PersonAdd />;
      case "driver":
        return <PersonAdd />;
      case "report":
        return <Article />;
      case "planner":
        return <EventNote />;
      case "addOnCharge":
        return <Payment />;
      case "promotion":
        return <LocalOffer />;
      case "quickbooks":
        return <AccountBalanceOutlined />;
      default:
        return null;
    }
  };

  return title ? (
    <>
      {isWithIcon ? (
        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            bgcolor="primary.contrastText"
            color="primary.main"
            borderRadius="50%"
            p={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <SvgIcon {...props} fontSize={fontSize}>
              {getIconComponent()}
            </SvgIcon>

            <Typography variant="h5" color="primary" sx={{ ml: 1 }}>
              {title}
            </Typography>
          </Box>
        </Stack>
      ) : (
        <Typography
          fontSize={"45px"}
          fontWeight={700}
          color="primary"
          sx={{ lineHeight: "42px" }}
        >
          {title}
        </Typography>
      )}
    </>
  ) : (
    <SvgIcon {...props} fontSize={fontSize}>
      {getIconComponent()}
    </SvgIcon>
  );
};

export default React.memo(IconComponent);
